const dayMap = {
    Mo: 'Montags',
    Tu: 'Dienstags',
    We: 'Mittwochs',
    Th: 'Donnerstags',
    Fr: 'Freitags',
    Sa: 'Samstags',
    Su: 'Sonntags',
};

export default function parseAndTranslateOsmTimeString(time) {
    if (!time) return [];

    return time
        .split(';')
        .filter((frame) => !!frame.trim())
        .map((frame) => {
            const [day, intervals] = frame.trim().split(' ');
            return {
                day: dayMap[day],
                intervals: intervals
                    .split(',')
                    .filter((i) => !!i.trim())
                    .join(' & '),
            };
        });
}
